import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { CommonService } from "src/app/Service/Common.service";
import { environment } from '../../../environments/environment'

@Component({
    selector: 'app-forge-viewer',
    templateUrl: './forge-viewer.component.html'
})
export class ForgeViewerComponent implements OnInit {
    viewerUrl: string = environment.viewerUrl;
    // viewerUrl: string =  "http://localhost:3001/forgeviewer/viewer?urn=";
    compareUrl:string = environment.compareUrl;
    // compareUrl:string = "http://localhost:3001/forgeviewer/compare?";
    urlSafe!: SafeResourceUrl;
    constructor(public commonService:CommonService, public sanitizer: DomSanitizer,public dialogRef: MatDialogRef<ForgeViewerComponent>,@Inject(MAT_DIALOG_DATA) public _data: any) { }
    ngOnInit() {
        if(!!this._data.fileUrn){
        let currentUserId:number = this.commonService.getLoggedInUserId();
        this.viewerUrl = this.viewerUrl+this._data.fileUrn+"&userId="+currentUserId;
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.viewerUrl);
        }
        else if(!!this._data.sourceUrn && !!this._data.destinationUrn){
            this.compareUrl = this.compareUrl+"urn1="+this._data.sourceUrn.urn+"&urn2="+this._data.destinationUrn.urn;
            this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.compareUrl);
        }
    }

    public togglePopupDialog() {
        this.dialogRef.close();
      }
}